/**
 * init Plyr object
 */

jQuery(document).ready(function ($) {

    $.initPlyr();
 
})

jQuery.initPlyr = function(){

    try {
        // multiple video player
        const players = Array.from(document.querySelectorAll('#player')).map(p => new Plyr(p, {
            loadSprite: false,
            iconUrl: CustomBlocks.pluginurl + "/vendor/plyr/plyr.svg"
        }));
    } catch (err) { }

   

}


// WEBPACK FOOTER //
// ./src/filters/youtube/script.js